import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-star\"><path d=\"M113.152 570.496l316.8-135.68L565.76 118.016 701.44 434.816l316.8 135.68L701.44 706.304 565.76 1023.104 430.08 706.304 113.024 570.624z\" fill=\"#8B81EB\" p-id=\"4610\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol